import React,{useState} from 'react';
import {motion,AnimatePresence} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiUsers,FiStar,FiMapPin,FiClock,FiTrendingUp,FiMail,FiPhone,FiGlobe,FiCalendar,FiX,FiExternalLink,FiInfo}=FiIcons;

const Community=()=> {
const [activeTab,setActiveTab]=useState('groups');
const [joinedGroups,setJoinedGroups]=useState(new Set([1,3]));
const [selectedGroup,setSelectedGroup]=useState(null);
const [showGroupModal,setShowGroupModal]=useState(false);

const tabs=[ 
{id: 'groups',name: 'Groups',icon: FiUsers},
{id: 'mentors',name: 'Mentors',icon: FiStar} 
];

const groups=[ 
{id: 1,name: 'Small Business Owners',description: 'Conservative entrepreneurs sharing strategies and supporting free market principles.',members: 2847,posts: 156,category: 'Business',image: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=100&h=100&fit=crop',tags: ['Entrepreneurship','Free Market','Business'],bio: 'Our Small Business Owners group is a thriving community of conservative entrepreneurs who believe in the power of free market capitalism. We share business strategies,networking opportunities,and advocate for policies that support small business growth. Members include restaurant owners,tech entrepreneurs,retail business owners,and service providers who are committed to building successful businesses while upholding conservative values.',meetingInfo: {frequency: 'Monthly',day: 'First Wednesday',time: '7:00 PM - 9:00 PM',location: 'Chamber of Commerce Building,123 Business Ave,Houston,TX',virtualOption: true},contact: {organizer: 'Sarah Johnson',email: 'sarah.johnson@smallbizgop.org',phone: '(713) 555-0123'},website: 'https://smallbusinessgop.org',founded: '2019',achievements: [ 'Helped 150+ businesses navigate COVID-19 challenges','Lobbied for small business tax relief legislation','Created mentorship program pairing experienced with new entrepreneurs' ]},{id: 2,name: 'Second Amendment Advocates',description: 'Defending constitutional rights and promoting responsible gun ownership.',members: 5234,posts: 289,category: 'Rights',image: 'https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=100&h=100&fit=crop',tags: ['2A','Constitution','Rights'],bio: 'The Second Amendment Advocates group is dedicated to protecting and defending our constitutional right to keep and bear arms. We educate members about firearms safety,advocate for Second Amendment rights,and work to counter anti-gun legislation. Our members include hunters,sport shooters,law enforcement officers,military veterans,and concerned citizens who believe in the fundamental right to self-defense.',meetingInfo: {frequency: 'Bi-weekly',day: 'Every other Saturday',time: '10:00 AM - 12:00 PM',location: 'American Legion Post 123,456 Freedom Rd,Dallas,TX',virtualOption: false},contact: {organizer: 'Mike Rodriguez',email: 'mike.rodriguez@2aadvocates.org',phone: '(214) 555-0456'},website: 'https://secondamendmentadvocates.org',founded: '2016',achievements: [ 'Successfully opposed 3 anti-gun bills in state legislature','Trained over 1,000 citizens in firearms safety','Organized annual Second Amendment rally with 5,000+ attendees' ]},{id: 3,name: 'Homeschool Parents',description: 'Supporting families choosing educational freedom and traditional values.',members: 1923,posts: 445,category: 'Education',image: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=100&h=100&fit=crop',tags: ['Education','Family','Parental Rights'],bio: 'Our Homeschool Parents group supports families who have chosen to educate their children at home based on conservative values and educational freedom. We provide curriculum recommendations,organize field trips,share teaching resources,and advocate for homeschool rights. Members range from new homeschooling families to seasoned educators with decades of experience.',meetingInfo: {frequency: 'Weekly',day: 'Thursday',time: '10:00 AM - 12:00 PM',location: 'Rotating member homes and community centers',virtualOption: true},contact: {organizer: 'Jennifer Martinez',email: 'jennifer.martinez@homeschoolpatriots.org',phone: '(512) 555-0789'},website: 'https://homeschoolpatriots.org',founded: '2018',achievements: [ 'Created comprehensive K-12 conservative curriculum guide','Organized 50+ educational field trips annually','Successfully defended homeschool rights in local school board meetings' ]},{id: 4,name: 'Military Veterans',description: 'Connecting veterans who served our country with honor and continue fighting for freedom.',members: 3456,posts: 203,category: 'Service',image: 'https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=100&h=100&fit=crop',tags: ['Veterans','Service','Honor'],bio: 'The Military Veterans group brings together those who have served our nation in uniform and continue to serve their communities as civilians. We provide support for veterans transitioning to civilian life,advocate for veteran benefits and healthcare,and work to honor the memory of fallen comrades. Our members span all branches of service and eras of conflict.',meetingInfo: {frequency: 'Monthly',day: 'Third Sunday',time: '2:00 PM - 4:00 PM',location: 'VFW Post 9876,789 Veteran Way,San Antonio,TX',virtualOption: true},contact: {organizer: 'Colonel (Ret.) James Patterson',email: 'james.patterson@veteransunited.org',phone: '(210) 555-0321'},website: 'https://conservativeveterans.org',founded: '2015',achievements: [ 'Helped 500+ veterans find employment','Raised $250,000 for veteran mental health programs','Established scholarship fund for military children' ]},{id: 5,name: 'Young Conservatives',description: 'Next generation leaders building the future of the conservative movement.',members: 4567,posts: 678,category: 'Youth',image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=100&h=100&fit=crop',tags: ['Youth','Leadership','Future'],bio: 'Young Conservatives is a dynamic group for conservative-minded individuals aged 18-35 who are passionate about preserving constitutional principles and traditional American values for future generations. We focus on political engagement,leadership development,and building a strong network of young conservative professionals and activists.',meetingInfo: {frequency: 'Bi-weekly',day: 'Every other Friday',time: '7:00 PM - 9:00 PM',location: 'Various locations - check website for current venue',virtualOption: true},contact: {organizer: 'Alex Thompson',email: 'alex.thompson@youngconservatives.org',phone: '(713) 555-0654'},website: 'https://youngconservativetexas.org',founded: '2020',achievements: [ 'Registered 2,000+ young voters','Organized campus speaking events at 15+ universities','Launched mentorship program connecting young professionals with established leaders' ]},{id: 6,name: 'Faith and Freedom Coalition',description: 'Uniting people of faith to defend religious liberty and traditional values.',members: 6789,posts: 432,category: 'Faith',image: 'https://images.unsplash.com/photo-1507692049790-de58290a4334?w=100&h=100&fit=crop',tags: ['Faith','Religious Liberty','Values'],bio: 'The Faith and Freedom Coalition brings together Christians and people of faith who believe in defending religious liberty,protecting the sanctity of life,and upholding biblical values in public policy. We organize prayer events,advocate for religious freedom legislation,and support candidates who share our values.',meetingInfo: {frequency: 'Monthly',day: 'Second Tuesday',time: '7:30 PM - 9:00 PM',location: 'First Baptist Church Fellowship Hall,321 Faith St,Austin,TX',virtualOption: false},contact: {organizer: 'Pastor David Wilson',email: 'david.wilson@faithfreedom.org',phone: '(512) 555-0987'},website: 'https://faithandfreedomtx.org',founded: '2017',achievements: [ 'Successfully defended religious exemptions in healthcare mandates','Organized annual Prayer Breakfast with 1,500+ attendees','Supported pro-life legislation resulting in 3 major bills passed' ]} 
];

const mentors=[ 
{id: 1,name: 'Sarah Johnson',title: 'Former State Senator',expertise: ['Political Strategy','Campaign Management','Public Speaking'],experience: '15 years',rating: 4.9,sessions: 127,photo: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face',bio: 'Experienced political strategist helping conservatives run effective campaigns.',location: 'Austin,TX'},{id: 2,name: 'Michael Chen',title: 'Business Executive',expertise: ['Entrepreneurship','Leadership','Free Market Economics'],experience: '20 years',rating: 4.8,sessions: 89,photo: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face',bio: 'CEO and entrepreneur passionate about mentoring the next generation of conservative leaders.',location: 'Miami,FL'},{id: 3,name: 'Rebecca Martinez',title: 'Legal Advocate',expertise: ['Constitutional Law','Civil Rights','Legal Strategy'],experience: '12 years',rating: 4.9,sessions: 156,photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face',bio: 'Constitutional lawyer defending religious liberty and conservative values in court.',location: 'Phoenix,AZ'} 
];

const toggleGroupMembership=(groupId)=> {
const newJoined=new Set(joinedGroups);
if (newJoined.has(groupId)) {
newJoined.delete(groupId);
} else {
newJoined.add(groupId);
} 
setJoinedGroups(newJoined);
};

const openGroupModal=(group)=> {
setSelectedGroup(group);
setShowGroupModal(true);
};

const closeGroupModal=()=> {
setSelectedGroup(null);
setShowGroupModal(false);
};

const renderStars=(rating)=> {
return Array.from({length: 5},(_,i)=> ( 
<SafeIcon key={i} icon={FiStar} className={`h-4 w-4 ${i < Math.floor(rating) ? 'text-yellow-400 fill-current' : 'text-gray-300'}`} /> 
));
};

return ( 
<div className="min-h-screen bg-gray-50 py-8"> 
<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> 
{/* Header */} 
<motion.div initial={{opacity: 0,y: 30}} animate={{opacity: 1,y: 0}} transition={{duration: 0.6}} className="text-center mb-12" > 
<h1 className="text-4xl font-bold text-patriot-navy mb-4">Patriot Community</h1> 
<p className="text-xl text-gray-600 max-w-3xl mx-auto"> 
Connect with like-minded conservatives,join interest groups,find mentors,and engage with fellow patriots who share your values. 
</p> 
</motion.div> 

{/* Tabs */} 
<div className="mb-8"> 
<div className="flex flex-wrap gap-2"> 
{tabs.map((tab)=> ( 
<button key={tab.id} onClick={()=> setActiveTab(tab.id)} className={`flex items-center px-4 py-2 rounded-lg font-medium transition-colors duration-200 ${activeTab===tab.id ? 'bg-patriot-red text-white' : 'bg-white text-gray-700 hover:bg-gray-100'}`} > 
<SafeIcon icon={tab.icon} className="h-4 w-4 mr-2" /> 
{tab.name} 
</button> 
))} 
</div> 
</div> 

{/* Content */} 
{activeTab==='groups' && ( 
<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"> 
{groups.map((group,index)=> ( 
<motion.div key={group.id} initial={{opacity: 0,y: 30}} animate={{opacity: 1,y: 0}} transition={{duration: 0.6,delay: index * 0.1}} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300" > 
<div className="p-6"> 
<div className="flex items-start justify-between mb-4"> 
<div className="flex items-center space-x-3"> 
<img src={group.image} alt={group.name} className="w-12 h-12 rounded-lg object-cover" /> 
<div> 
<h3 className="text-lg font-semibold text-patriot-navy"> 
{group.name} 
</h3> 
<span className="text-sm text-gray-600">{group.category}</span> 
</div> 
</div> 
</div> 
<p className="text-gray-600 text-sm mb-4 line-clamp-2"> 
{group.description} 
</p> 
<div className="flex items-center justify-between text-sm text-gray-600 mb-4"> 
<span className="flex items-center"> 
<SafeIcon icon={FiUsers} className="h-4 w-4 mr-1" /> 
{group.members.toLocaleString()} members 
</span> 
</div> 
<div className="flex flex-wrap gap-1 mb-4"> 
{group.tags.slice(0,3).map((tag,idx)=> ( 
<span key={idx} className="px-2 py-1 bg-gray-100 text-gray-700 text-xs rounded-full" > 
{tag} 
</span> 
))} 
</div> 
<div className="space-y-2"> 
<button onClick={()=> openGroupModal(group)} className="w-full py-2 px-4 rounded-lg font-medium transition-colors duration-200 bg-patriot-navy text-white hover:bg-patriot-navy-dark" > 
Learn More 
</button> 
<button onClick={()=> toggleGroupMembership(group.id)} className={`w-full py-2 px-4 rounded-lg font-medium transition-colors duration-200 ${joinedGroups.has(group.id) ? 'bg-green-600 text-white hover:bg-green-700' : 'bg-patriot-red text-white hover:bg-patriot-red-dark'}`} > 
{joinedGroups.has(group.id) ? 'Joined' : 'Join Group'} 
</button> 
</div> 
</div> 
</motion.div> 
))} 
</div> 
)} 

{activeTab==='mentors' && ( 
<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"> 
{mentors.map((mentor,index)=> ( 
<motion.div key={mentor.id} initial={{opacity: 0,y: 30}} animate={{opacity: 1,y: 0}} transition={{duration: 0.6,delay: index * 0.1}} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300" > 
<div className="p-6"> 
<div className="flex items-center space-x-4 mb-4"> 
<img src={mentor.photo} alt={mentor.name} className="w-16 h-16 rounded-full object-cover" /> 
<div> 
<h3 className="text-lg font-semibold text-patriot-navy"> 
{mentor.name} 
</h3> 
<p className="text-gray-600 text-sm">{mentor.title}</p> 
<div className="flex items-center space-x-1 mt-1"> 
{renderStars(mentor.rating)} 
<span className="text-sm text-gray-600 ml-1"> 
({mentor.sessions} sessions) 
</span> 
</div> 
</div> 
</div> 
<p className="text-gray-600 text-sm mb-4"> 
{mentor.bio} 
</p> 
<div className="mb-4"> 
<h4 className="text-sm font-medium text-gray-900 mb-2">Expertise:</h4> 
<div className="flex flex-wrap gap-1"> 
{mentor.expertise.map((skill,idx)=> ( 
<span key={idx} className="px-2 py-1 bg-patriot-red bg-opacity-10 text-patriot-red text-xs rounded-full" > 
{skill} 
</span> 
))} 
</div> 
</div> 
<div className="flex items-center justify-between text-sm text-gray-600 mb-4"> 
<span className="flex items-center"> 
<SafeIcon icon={FiMapPin} className="h-4 w-4 mr-1" /> 
{mentor.location} 
</span> 
<span>{mentor.experience} experience</span> 
</div> 
<button className="w-full bg-patriot-red text-white px-4 py-2 rounded-lg hover:bg-patriot-red-dark transition-colors duration-200 font-medium"> 
Request Mentorship 
</button> 
</div> 
</motion.div> 
))} 
</div> 
)} 

{/* Group Detail Modal */} 
<AnimatePresence> 
{showGroupModal && selectedGroup && ( 
<div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-y-auto"> 
<motion.div initial={{opacity: 0,scale: 0.9}} animate={{opacity: 1,scale: 1}} exit={{opacity: 0,scale: 0.9}} className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" > 
<div className="relative"> 
<img src={selectedGroup.image} alt={selectedGroup.name} className="w-full h-48 md:h-64 object-cover" /> 
<button onClick={closeGroupModal} className="absolute top-4 right-4 bg-white rounded-full p-2 shadow-md hover:bg-gray-100 transition-colors duration-200" > 
<SafeIcon icon={FiX} className="h-5 w-5 text-gray-700" /> 
</button> 
<div className="absolute bottom-4 left-4"> 
<span className="bg-patriot-red text-white px-3 py-1 rounded-full text-sm font-medium"> 
{selectedGroup.category} 
</span> 
</div> 
</div> 
<div className="p-6"> 
<div className="flex items-center justify-between mb-6"> 
<div> 
<h2 className="text-2xl font-bold text-patriot-navy mb-2"> 
{selectedGroup.name} 
</h2> 
<div className="flex items-center text-gray-600 space-x-4"> 
<span className="flex items-center"> 
<SafeIcon icon={FiUsers} className="h-4 w-4 mr-1" /> 
{selectedGroup.members.toLocaleString()} members 
</span> 
<span className="flex items-center"> 
<SafeIcon icon={FiCalendar} className="h-4 w-4 mr-1" /> 
Founded {selectedGroup.founded} 
</span> 
</div> 
</div> 
</div> 
<div className="grid grid-cols-1 lg:grid-cols-2 gap-8"> 
<div> 
<h3 className="text-lg font-semibold text-patriot-navy mb-3">About This Group</h3> 
<p className="text-gray-700 mb-6 leading-relaxed"> 
{selectedGroup.bio} 
</p> 
<h3 className="text-lg font-semibold text-patriot-navy mb-3">Key Achievements</h3> 
<ul className="space-y-2 mb-6"> 
{selectedGroup.achievements.map((achievement,idx)=> ( 
<li key={idx} className="flex items-start"> 
<SafeIcon icon={FiInfo} className="h-4 w-4 text-patriot-red mr-2 mt-0.5 flex-shrink-0" /> 
<span className="text-gray-700 text-sm">{achievement}</span> 
</li> 
))} 
</ul> 
<div className="flex flex-wrap gap-2"> 
{selectedGroup.tags.map((tag,idx)=> ( 
<span key={idx} className="px-3 py-1 bg-patriot-red bg-opacity-10 text-patriot-red text-sm rounded-full" > 
{tag} 
</span> 
))} 
</div> 
</div> 
<div> 
<h3 className="text-lg font-semibold text-patriot-navy mb-3">Meeting Information</h3> 
<div className="bg-gray-50 rounded-lg p-4 mb-6"> 
<div className="space-y-3"> 
<div className="flex items-center"> 
<SafeIcon icon={FiClock} className="h-4 w-4 text-patriot-red mr-2" /> 
<div> 
<span className="font-medium">Schedule:</span> 
<p className="text-gray-600 text-sm"> 
{selectedGroup.meetingInfo.frequency} - {selectedGroup.meetingInfo.day} 
</p> 
<p className="text-gray-600 text-sm"> 
{selectedGroup.meetingInfo.time} 
</p> 
</div> 
</div> 
<div className="flex items-start"> 
<SafeIcon icon={FiMapPin} className="h-4 w-4 text-patriot-red mr-2 mt-1" /> 
<div> 
<span className="font-medium">Location:</span> 
<p className="text-gray-600 text-sm"> 
{selectedGroup.meetingInfo.location} 
</p> 
{selectedGroup.meetingInfo.virtualOption && ( 
<p className="text-green-600 text-sm"> 
Virtual attendance available 
</p> 
)} 
</div> 
</div> 
</div> 
</div> 
<h3 className="text-lg font-semibold text-patriot-navy mb-3">Contact Information</h3> 
<div className="bg-gray-50 rounded-lg p-4 mb-6"> 
<div className="space-y-2"> 
<div className="flex items-center"> 
<SafeIcon icon={FiUsers} className="h-4 w-4 text-patriot-red mr-2" /> 
<span className="font-medium">Organizer:</span> 
<span className="ml-2 text-gray-700">{selectedGroup.contact.organizer}</span> 
</div> 
<div className="flex items-center"> 
<SafeIcon icon={FiMail} className="h-4 w-4 text-patriot-red mr-2" /> 
<a href={`mailto:${selectedGroup.contact.email}`} className="text-blue-600 hover:underline" > 
{selectedGroup.contact.email} 
</a> 
</div> 
<div className="flex items-center"> 
<SafeIcon icon={FiPhone} className="h-4 w-4 text-patriot-red mr-2" /> 
<a href={`tel:${selectedGroup.contact.phone}`} className="text-blue-600 hover:underline" > 
{selectedGroup.contact.phone} 
</a> 
</div> 
{selectedGroup.website && ( 
<div className="flex items-center"> 
<SafeIcon icon={FiGlobe} className="h-4 w-4 text-patriot-red mr-2" /> 
<a href={selectedGroup.website} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline flex items-center" > 
Visit Website 
<SafeIcon icon={FiExternalLink} className="h-3 w-3 ml-1" /> 
</a> 
</div> 
)} 
</div> 
</div> 
<div className="space-y-3"> 
<button onClick={()=> toggleGroupMembership(selectedGroup.id)} className={`w-full py-3 px-4 rounded-lg font-medium transition-colors duration-200 ${joinedGroups.has(selectedGroup.id) ? 'bg-green-600 text-white hover:bg-green-700' : 'bg-patriot-red text-white hover:bg-patriot-red-dark'}`} > 
{joinedGroups.has(selectedGroup.id) ? 'Joined Group' : 'Join This Group'} 
</button> 
<button onClick={()=> window.open(`mailto:${selectedGroup.contact.email}?subject=Inquiry about ${selectedGroup.name}`,'_blank')} className="w-full py-3 px-4 rounded-lg font-medium border border-patriot-red text-patriot-red hover:bg-patriot-red hover:text-white transition-colors duration-200" > 
Contact Organizer 
</button> 
</div> 
</div> 
</div> 
</div> 
</motion.div> 
</div> 
)} 
</AnimatePresence> 
</div> 
</div> 
);
};

export default Community;